import React, { useMemo } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { LearnDataProps } from "../../../../../service/CourseDetail/resource";
import SourceInfo from "../../../../../components/CourseComponents/Resource/ListItem/Components/SourceInfo";

interface VoteHeaderProps {
    data: LearnDataProps | null;
}

export default function VoteHeader({ data }: VoteHeaderProps) {
    const history = useHistory();

    const Rate = useMemo(() => {
        const rate = (
            ((data?.dcCoursewareSourceStatics?.hasLearnNumber || 0) /
                (data?.dcCoursewareSourceStatics?.totalNumber || 0)) *
            100
        ).toFixed(2);
        return rate;
    }, [data]);
    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <div className={style.left}>
                    <h1 className={style.title}>
                        <Tooltip
                            title={data?.sourceFileEntity?.fileName}
                            placement="bottomLeft">
                            <span>{data?.sourceFileEntity?.fileName}</span>
                        </Tooltip>

                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    <div className={style.info}>
                        {data && <SourceInfo source={data} />}
                    </div>
                </div>

                <div className={style.right}>
                    <span className={style.percent}>参与率 {Rate}%</span>
                </div>
            </div>
        </div>
    );
}
